<template>
  <div>
    <v-row>
      <v-col>
        <v-row
          class="color-suva-grey font-size-lg-res font-weight-semibold mb-5"
          no-gutters
        >
          <v-col cols="2">Qty</v-col>
          <v-col cols="6">Description</v-col>
          <v-col
            class="text-right"
            :cols="updates ? 2 : 4"
            :class="{ 'pr-10': updates }"
            >Total</v-col
          >
          <v-col cols="2" v-if="updates">Order Updates</v-col>
        </v-row>
        <v-row class="d-flex flex-column" no-gutters>
          <v-col
            v-for="product in products"
            :key="product.item_id"
            class="pb-2 product-row"
          >
            <v-row no-gutters>
              <v-col
                cols="2"
                :data-orderdetails-qty="product.upc"
                :class="{ unactual: updates && product.pickStatus }"
              >
                {{
                  product.byweight ? byWeightDisplay(product.qty) : product.qty
                }}
              </v-col>
              <v-col
                cols="6"
                :data-orderdetails-name="product.upc"
                :class="{
                  unactual:
                    updates &&
                    product.pickStatus &&
                    (product.pickStatus.isNotAvailable ||
                      product.pickStatus.replaceToUpc),
                }"
              >
                {{ product.name }}
              </v-col>
              <v-col
                class="text-right"
                :class="{
                  unactual: updates && product.pickStatus,
                  'pr-10': updates,
                }"
                :cols="updates ? 2 : 4"
              >
                <PriceDisplay
                  v-if="
                    !product.is_redemption &&
                    !product.redemption_points_offer_id
                  "
                  :price="product.priceWithModifiers"
                  :qty="parseFloat(product.qty)"
                  :data-orderdetails-price="product.upc"
                />
                <span v-else style="color: red">Free <br /></span>
                <span
                  class="color-suva-grey font-size-sm text-right"
                  v-if="product.redemption_points_offer_id"
                  >({{ getProductPoints(product) }} point<span
                    v-if="getProductPoints(product) > 1"
                    >s</span
                  >)</span
                >
                <span
                  class="color-suva-grey font-size-sm text-right"
                  v-if="product.is_redemption"
                >
                  (Club Reward)</span
                >
                <UnitPriceDisplay
                  v-if="
                    parseFloat(product.qty) !== 1 &&
                    !product.is_redemption &&
                    !product.redemption_points_offer_id
                  "
                  :byweight="product.byweight"
                  :type="'summary'"
                  :unitPrice="
                    product.byweight ? product.cents * 100 : product.cents
                  "
                  :data-orderdetails-unitprice="product.upc"
                />
                <!--
                unit price above is adjusted (cents x 100) for this use of
                UnitPriceDisplay because shared-lib returns qty x 100 for
                byweight items
                -->
              </v-col>
              <v-col v-if="updates">
                <div
                  class="d-flex align-center"
                  v-if="product.pickStatus && product.pickStatus.isNotAvailable"
                >
                  <Icon
                    name="status_notAvailable"
                    color="#E21B23"
                    :style="{ height: '20', width: '20', marginRight: '12' }"
                  />
                  Unavailable
                </div>
                <div
                  class="d-flex align-center"
                  v-if="
                    product.pickStatus &&
                    product.pickStatus.replaceToUpc &&
                    product.pickStatus.replaceToQty
                  "
                >
                  <Icon
                    name="status_replaced"
                    :color="$vuetify.theme.themes.light.primary"
                    :style="{ height: '20', width: '20', marginRight: '12' }"
                  />
                  Replaced Item
                </div>
              </v-col>
            </v-row>
            <div v-if="product.modifiers && product.modifiers.length">
              <v-row
                v-for="modifier in product.modifiers"
                :key="modifier.item_id"
                no-gutters
              >
                <v-col
                  offset="2"
                  cols="7"
                  class="color-suva-grey font-size-sm"
                  :class="{
                    unactual:
                      updates &&
                      product.pickStatus &&
                      (product.pickStatus.isNotAvailable ||
                        product.pickStatus.replaceToUpc),
                  }"
                  >{{ modifier.name }}
                </v-col>
                <v-col
                  v-if="modifier.cents"
                  cols="3"
                  class="color-suva-grey font-size-sm text-right"
                  :class="{
                    unactual:
                      updates &&
                      product.pickStatus &&
                      (product.pickStatus.isNotAvailable ||
                        product.pickStatus.replaceToUpc),
                  }"
                  >(+{{ formatCurrency(modifier.cents) }})
                </v-col>
              </v-row>
            </div>
            <v-row
              v-if="product.pickStatus && !product.pickStatus.isNotAvailable"
              no-gutters
              class="replacement"
              :style="{ color: $vuetify.theme.themes.light.primary }"
            >
              <v-col cols="2">
                {{
                  product.pickStatus.replaceDetails.byweight
                    ? byWeightDisplay(product.pickStatus.replaceDetails.qty)
                    : product.pickStatus.replaceDetails.qty
                }}
              </v-col>
              <v-col cols="6">
                <span v-if="product.pickStatus.replaceToUpc">{{
                  product.pickStatus.replaceDetails.name
                }}</span>
              </v-col>
              <v-col cols="2" class="text-right pr-10">
                <PriceDisplay
                  :price="product.pickStatus.replaceDetails.priceWithModifiers"
                  :qty="parseFloat(product.pickStatus.replaceDetails.qty)"
                  :data-orderdetails-price="
                    product.pickStatus.replaceDetails.upc
                  "
                />
                <UnitPriceDisplay
                  v-if="parseFloat(product.pickStatus.replaceDetails.qty) !== 1"
                  :byweight="product.pickStatus.replaceDetails.byweight"
                  :type="'summary'"
                  :unitPrice="
                    product.pickStatus.replaceDetails.byweight
                      ? product.pickStatus.replaceDetails.cents * 100
                      : product.pickStatus.replaceDetails.cents
                  "
                  :data-orderdetails-unitprice="
                    product.pickStatus.replaceDetails.upc
                  "
                />
              </v-col>
              <v-col>
                <div
                  class="d-flex align-center"
                  v-if="
                    product.pickStatus &&
                    product.pickStatus.replaceToUpc &&
                    !product.pickStatus.replaceToQty
                  "
                >
                  <Icon
                    name="status_replaced"
                    :color="$vuetify.theme.themes.light.primary"
                    :style="{ height: '20', width: '20', marginRight: '12' }"
                  />
                  Replaced Item
                </div>
                <div
                  class="d-flex align-center"
                  v-if="
                    product.pickStatus &&
                    product.pickStatus.replaceToQty &&
                    product.pickStatus.replaceDetails.byweight
                  "
                >
                  <Icon
                    name="status_modifiedWeight"
                    :color="$vuetify.theme.themes.light.primary"
                    :style="{ height: '20', width: '20', marginRight: '12' }"
                  />

                  {{ `${product.pickStatus.replaceDetails.qty} lbs available` }}
                </div>
                <div
                  class="d-flex align-center"
                  v-if="
                    product.pickStatus &&
                    product.pickStatus.replaceToQty &&
                    !product.pickStatus.replaceDetails.byweight
                  "
                >
                  <Icon
                    name="status_partial"
                    :color="$vuetify.theme.themes.light.primary"
                    :style="{ height: '20', width: '20', marginRight: '12' }"
                  />
                  {{
                    `${product.pickStatus.replaceDetails.qty}/${product.qty} available`
                  }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="summarize-heading-top">
      <v-col>
        <v-row
          class="color-suva-grey font-size-lg-res font-weight-semibold mb-5"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9">Summary</v-col>
          <v-col
            class="text-right"
            :class="{ 'pr-10': updates }"
            :cols="updates ? 2 : 3"
            >Total</v-col
          >
        </v-row>

        <!-- Subtotal -->
        <v-row class="mb-3" no-gutters>
          <v-col :cols="updates ? 8 : 9"
            >Subtotal
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <!--
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            ></v-progress-linear>
            -->
            <span data-orderdetails-subtotal>{{
              formatCurrency(calculateSubtotal())
            }}</span>
          </v-col>
        </v-row>

        <!-- First order discount -->
        <v-row
          v-if="firstOrderDiscount"
          class="color-fire-engine-red font-weight-semibold mb-3"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9"
            >First Order Discount
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <div class="position-relative" data-orderdetails-firstorder>
              -{{ formatCurrency(getMaxFirstOrderDiscount()) }}
            </div>
          </v-col>
        </v-row>

        <!-- Taxes and fees -->
        <v-row
          v-if="totals && (totals.fee || totals.tax)"
          :class="{ 'mb-3': !showTaxAndFeeDetails }"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9"
            >Taxes and Fees
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <!--
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            ></v-progress-linear>
            -->
            <div class="align-center d-flex">
              <div class="position-relative" data-orderdetails-taxnfees>
                {{ taxesAndFees }}
                <v-btn
                  class="position-absolute right-minus-18"
                  color="primary"
                  icon
                  x-small
                  @click="toggleTaxesAndFees"
                >
                  <v-icon v-if="showTaxAndFeeDetails"
                    >mdi-unfold-less-horizontal
                  </v-icon>
                  <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="showTaxAndFeeDetails" class="ma-0 pa-0">
          <v-col class="font-size-sm-res ma-0 pa-0">
            <v-row v-if="totals.tax" class="mb-3" no-gutters>
              <v-col :cols="updates ? 8 : 9" class="pl-2"
                >Taxes
                <OrderAsterisk />
              </v-col>
              <v-col
                :cols="updates ? 2 : 3"
                class="align-center d-flex justify-end"
                :class="{ 'pr-10': updates }"
              >
                <v-progress-linear
                  v-if="awaitingCartUpdate"
                  buffer-value="0"
                  stream
                ></v-progress-linear>
                <span v-else data-orderdetails-taxes>{{
                  formatCurrency(totals.tax)
                }}</span>
              </v-col>
            </v-row>
            <v-row v-if="totals.fee" class="mb-3" no-gutters>
              <v-col :cols="updates ? 8 : 9" class="pl-2"
                >Fees
                <OrderAsterisk />
              </v-col>
              <v-col
                :cols="updates ? 2 : 3"
                class="align-center d-flex justify-end"
                :class="{ 'pr-10': updates }"
              >
                <v-progress-linear
                  v-if="awaitingCartUpdate"
                  buffer-value="0"
                  stream
                ></v-progress-linear>
                <span v-else data-orderdetails-fees>{{
                  formatCurrency(totals.fee)
                }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Savings -->
        <v-row
          v-if="totals.saving"
          class="font-weight-semibold mb-3"
          no-gutters
        >
          <v-col class="position-relative" :cols="updates ? 8 : 9">
            <span class="order-details__savings-label"
              >Savings<OrderAsterisk
            /></span>
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <span class="order-details__savings-value">{{
              formatCurrency(totals.saving)
            }}</span>
          </v-col>
        </v-row>

        <!-- Delivery Fee -->
        <v-row
          v-if="deliveryAmount && !cart.awaitingDeliveryDataUpdate"
          class="mb-3"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9"
            >Delivery Fee
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            ></v-progress-linear>
            <span v-else>{{ formatCurrency(deliveryAmount) }}</span>
          </v-col>
        </v-row>

        <!-- Credit card fee -->
        <v-row v-if="totals.ccFee" class="mb-3" no-gutters>
          <v-col :cols="updates ? 8 : 9"
            >Credit Card Fee
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            ></v-progress-linear>
            <span v-else data-orderdetails-cashdiscount>{{
              formatCurrency(totals.ccFee)
            }}</span>
          </v-col>
        </v-row>

        <!-- Delivery tip -->
        <v-row
          v-if="totals.driverTip && !cart.awaitingDeliveryDataUpdate"
          class="mb-3"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9"
            >Delivery Tip
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end"
            :class="{ 'pr-10': updates }"
          >
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            ></v-progress-linear>
            <span v-else>{{ formatCurrency(totals.driverTip) }}</span>
          </v-col>
        </v-row>

        <!-- Total -->
        <v-row
          v-if="totals"
          class="mb-2 font-weight-semibold primary--text order-details__total"
          no-gutters
        >
          <v-col :cols="updates ? 8 : 9" class="order-details__total-label">
            Total
            <OrderAsterisk />
          </v-col>
          <v-col
            :cols="updates ? 2 : 3"
            class="align-center d-flex justify-end order-details__total-value"
            :class="{ 'pr-10': updates }"
          >
            <v-progress-linear
              v-if="awaitingCartUpdate"
              buffer-value="0"
              stream
            >
            </v-progress-linear>
            <!--
            <span v-else data-orderdetails-total>{{ total }}</span>
            -->
            <span v-else data-orderdetails-total>{{
              formatCurrency(totals.total)
            }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <p v-if="!serviceIsDelivery" class="estimated-total-text">
      *Estimated. Actual amounts will be calculated during checkout at the store
    </p>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { byWeightDisplay, formatCurrency } from "@/util.js";
import PriceDisplay from "@/components/Product/PriceDisplay.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import Icon from "@/components/UI/Icon.vue";
import OrderAsterisk from "@/components/Order/OrderAsterisk.vue";
// import UnitPriceDisplayWithModifiers from "@/components/Product/UnitPriceDisplayWithModifiers.vue";

export default {
  name: "OrderDetails",
  // components: { PriceDisplay, UnitPriceDisplay, UnitPriceDisplayWithModifiers },
  components: { OrderAsterisk, Icon, PriceDisplay, UnitPriceDisplay },
  computed: {
    taxesAndFees() {
      return this.formatCurrency(this.totals.tax + this.totals.fee);
    },
    ...mapGetters("store", {
      getPointsOffer: "getPointsOffer",
    }),
    ...mapState({
      order: (state) => state.orders.order,
      cart: (state) => state.cart,
    }),
    serviceIsDelivery() {
      return this.$store.getters["orders/serviceIsDelivery"] === "DELIVERY";
    },
  },
  data() {
    return {
      showTaxAndFeeDetails: false,
    };
  },
  methods: {
    byWeightDisplay,
    calculateSubtotal() {
      let loyaltySavings = this.products.reduce((i, p) => {
        return p.is_redemption || p.redemption_points_offer_id
          ? i + p.cents * p.qty
          : i;
      }, 0);
      return this.totals.subtotal - this.deliveryAmount - loyaltySavings;
    },
    formatCurrency,
    getMaxFirstOrderDiscount() {
      const subtotal = this.totals.subtotal - this.deliveryAmount;
      return Math.min(subtotal, this.firstOrderDiscount);
    },
    getProductPoints(product) {
      return (
        this.getPointsOffer(product.redemption_points_offer_id).points *
        product.qty
      );
    },
    toggleTaxesAndFees() {
      this.showTaxAndFeeDetails = !this.showTaxAndFeeDetails;
    },
  },
  props: {
    awaitingCartUpdate: Boolean,
    deliveryAmount: Number,
    firstOrderDiscount: Number,
    items: Object,
    products: Array,
    totals: Object,
    updates: Boolean,
  },
};
</script>
<style lang="scss" scoped>
.order-details {
  &__savings {
    &-label {
      left: -6px;
      position: absolute;
      border-radius: 10px;
      background-color: #d7ece0;
      padding: 2px 6px;
      color: var(--color-green);
    }

    &-value {
      color: var(--color-green);
      border-radius: 10px;
      background-color: #d7ece0;
      margin-left: auto;
      padding: 2px 6px;
    }
  }

  &__total {
    font-size: 20px;

    &-label {
      color: var(--v-primary);
    }

    &-value {
      color: var(--v-primary);
    }
  }
}

.estimated-total-text {
  margin: 30px 0 10px 0;
  font-size: 12px;
  color: #9e9e9e;
}

.unactual {
  color: #9e9e9e;
  text-decoration-line: line-through;
}

.summarize-heading-top {
  border-top: 2px solid #dbdbdb;
}

.product-row:not(:last-child)::after {
  content: "";
  display: block;
  width: 98%;
  margin: 8px auto;
  border-bottom: 1px solid #dbdbdb;
}

.right-minus-18 {
  top: 2px;
  right: -18px;
}
</style>
